import Cross from "assets/svgs/cross";
import Send from "assets/svgs/send";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useSetChat } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useFreshChatData } from "modules/dashboards/actionables/store";

const options = [
  { label: "Cx Not Answering", value: "cx_not_answering_2" },
  { label: "Cx Not filled Hair Test", value: "rx_product_no_hairtest" },
  { label: "Answer to Doctor Escalation", value: "doctor_escalation_v2" },
  { label: "Reminder to Place Order", value: "order_reminder_native_temp_v2" },
  { label: "Upload Scalp Pic", value: "scalp_photo_upload_v2" },
  { label: "Upload AI Scanned Scalp Pic", value: "scalp_photo_upload_ai" },
  {
    label: "Cx has not answered for 15+ Days",
    value: "15days_cx_not_answering_v2",
  },
  { label: "Delay in Delivery", value: "delivery_delay_v2" },
  { label: "New address Request", value: "new_address_request_v2" },
  { label: "Send booking link", value: "send_booking_link_v2" },
  { label: "Start a conversation", value: "start_conversation" },
  { label: "Send Upload documents link", value: "medical_document_v2" },
  { label: "Other", value: "other" },
  { label: "NPS Feedback Link", value: "nps_feedback_link" },
  { label: "CRM Order Confirmation", value: "crm_order_confirmation" },
  {label: "Semi-filled Call Booked", value: "semifilled_callbooked"}
];


const customStyles = {
  placeholder: (provided) => ({
    ...provided,
    opacity: 0.4,
  }),
  control: (provided) => ({
    ...provided,
    borderTopRightRadius: "0",
    borderBottomRightRadius: "0",
    borderRight: "none",
    width: "100%",
  }),
};

function SelectAndInput({ customer, whatsAppDndFlag}) {
  const { setChatMessage } = useSetChat();
  const { fetchFreshChatData } = useFreshChatData();
  const [input, setInput] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [customMessage, setCustomMessage] = useState(null);
  const ref = useRef();

  const { setToaster } = useToast();
  useEffect(() => {
    input && ref.current.focus();
  }, [input]);

  const handleChange = (selectedOption) => {
    if (selectedOption && selectedOption.value === "other") {
      setInput(true);
    } else {
      setInput(false);
      setSelectedValue(selectedOption);
    }
  };

  const handleSubmit = () => {
    if (customMessage) {
      setCustomMessage(null);
      setSelectedValue(null);
      setChatMessage(
        customer.id,
        customMessage,
        fetchFreshChatData
      );
    } else if (selectedValue) {
      setChatMessage(
        customer.id,
        selectedValue.value,
        fetchFreshChatData
      );
    }
  };

  return (
    <div className="d-flex w-100 align-items-center p-0">
      <div style={{ width: "100%" }}>
        {input ? (
          <div
            style={{
              border: "1px solid #ddd",
              padding: ".5rem 1.3rem",
              borderTopLeftRadius: ".3rem",
              borderBottomLeftRadius: ".3rem",
            }}
            className="w-100  px-3  d-flex align-items-center bg-white justify-content-between"
          >
            <input
              ref={ref}
              style={{ padding: ".38rem 2rem .38rem .2rem", width: "100%" }}
              className="border-0 outline-none"
              placeholder="Other"
              onChange={(event) => {
                setCustomMessage(event.target.value);
              }}
            />
            <div
              className="ms-n5"
              onClick={() => {
                setInput(false);
              }}
            >
              <Cross />
            </div>
          </div>
        ) : (
          <div style={{ width: "100%" }}>
            <Select
              className="m-0"
              options={options}
              placeholder="Message..."
              onChange={handleChange}
              isClearable
              isSearchable
              styles={customStyles}
              isDisabled={whatsAppDndFlag?true:false}
            />
          </div>
        )}
      </div>
      <button
        style={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
        className="btn btn-primary h-100"
        onClick={handleSubmit}
      >
        <Send />
      </button>
    </div>
  );
}

export default SelectAndInput;
